export const primary = '#00004d';
export const secondary = '#0000cc';
export const loadingColor = '#0000cc';
export const success = '#2ecc71';
export const error = '#e74c3c';
export const warn = '#F1C40F';
export const white = '#FFFFFF';
export const black = '#000000';
export const darkGray = '#121212';
export const middleGray = '#868686';
export const middleGraySecondary = '#5c5a5a';
export const lightGray = '#d1d2d4';
export const lighterGray = '#fafafa';
export const lighterPrimary = '#fafcff';
export const primaryGradient = `linear-gradient(90deg, #0000cc 0%, #0000cc 100%)`;
export const lineGradient = 'linear-gradient(73deg, #22305b 0%, #3c7dc0 50%, #3c7dc0 100%)';
